<template>
    <div class="shadow-lg p-3 mb-5 bg-white rounded">
        <Header :titulo="Titulo" />
        <hr/>
        <Contenedor :tipo="Tipo" :titulo="Titulo" :estado="Estado"></Contenedor>
    </div>

</template>

<script>
    import Contenedor from '@//components/Contenedor.vue';
    import Header from '@//components/Header.vue';

    export default {
        name: 'entradas',
		
        components: {
            Contenedor,
            Header
        },
        beforeUpdate: function(){
            this.$router.go(0); 
          
        },
 
        computed: {
            Tipo() {
             
                let aux_tipo = this.tipos_titulo.filter(x => x.tipo == "entradas");
               
                 return aux_tipo[0].tipo;
               
            },
           
            Titulo() {
            
                let aux_titulo = this.tipos_titulo.filter(x => x.tipo == "entradas");
                this.$route.meta.title = aux_titulo[0].titulo;
                return aux_titulo[0].titulo;

            },
            Estado() {

                return 'Nuevo';

            },
        },
        methods: {
            methodThatForcesUpdate() {
                // ...
            
                Object.assign(this.$data, this.$options.data());
                this.$forceUpdate();  // Notice we have to use a $ here
                // ...
            }
        },
        data: function () {
            return {
                
                tipos_titulo: [{ tipo: 'entradas', titulo: 'DISEÑAR MI ENTRADA' }, {tipo: 'pulseras', titulo: 'DISEÑAR MI PULSERA' }],
                
               
            }
        },
    };

</script>

<style>
</style>

